import React from 'react';
import { Button, withStyles } from 'components/common';

const DisputeSuccess = ({ close }) => (
  <div>
    <div className="px-10">
      <p className="mb text-center text-sm">Success</p>
      <p className="mb-6 font-title font-light text-xl text-center">Dispute submitted</p>
      <p className="text-center mb-6">
          We will review your transaction dispute request and get back to you within 12-14 business
          days.
      </p>
      <Button className="w-full" buttonColor="#99B5B7" onClick={close}>
          Back To Transactions
      </Button>
    </div>

  </div>
);

export default withStyles(DisputeSuccess);
